import { Form as FinalForm } from 'react-final-form';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { View } from 'foundations-components/transitional/components/View';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Form } from 'foundations-components/transitional/components/Form';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Select } from 'foundations-components/transitional/components/Select';
import { usePlaylist } from '../../../savedItems/savedItemsQueries';
import { Visibilities, Difficulties } from '../../hubspotPlaylistsConstants';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { useHistory } from 'quartz-routing/react-router';
import Raven from 'raven-js';
import UsageTracker from 'academy-common-lib/utils/UsageTracker';
import { notEmptyString, required } from 'academy-common-lib/utils/validation';
import { FinalFormField } from 'academy-common-lib/components/FinalForm';
import { useCreateHubspotPlaylistFromPlaylist, useUpdateHubspotPlaylist } from '../../hubspotPlaylistQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ErrorMessage = ({
  message
}) => /*#__PURE__*/_jsxs(Alert, {
  marginBlockEnd: "300",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.errors.badRequest.somethingsGoneWrong"
  }),
  type: "danger",
  children: [message, /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "academyCommon.errors.badRequest.keepsHappening"
  })]
});
const CreateOrEditHubspotPlaylistModal = ({
  playlistId,
  onClose,
  action = 'create'
}) => {
  const history = useHistory();
  const {
    playlist,
    playlistError,
    playlistLoading
  } = usePlaylist(playlistId);
  const {
    createHubspotPlaylistFromPlaylist,
    createHubspotPlaylistFromPlaylistLoading,
    createHubspotPlaylistFromPlaylistError
  } = useCreateHubspotPlaylistFromPlaylist({
    onCompleted: onSuccessfulCreation
  });
  const {
    updateHubspotPlaylist,
    updateHubspotPlaylistLoading,
    updateHubspotPlaylistError
  } = useUpdateHubspotPlaylist({
    playlistId,
    onCompleted: onSuccessfulUpdate
  });
  function onSuccessfulCreation({
    result
  }) {
    FloatingAlertStore.addAlert({
      message: I18n.text('academyCommon.playlists.hubspotPlaylists.createEditModal.successMessage'),
      type: 'success'
    });
    history.push(`/saved-items/playlists/${result.playlistId}`);
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'create-hubspot-playlist-modal-save-success'
    });
  }
  function onSuccessfulUpdate() {
    FloatingAlertStore.addAlert({
      message: I18n.text('academyCommon.playlists.hubspotPlaylists.createEditModal.successMessage'),
      type: 'success'
    });
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'edit-hubspot-playlist-modal-save-success'
    });
    onClose();
  }
  const handleCloseButtonClick = () => {
    UsageTracker.trackStandalone('Playlist Interaction', {
      action: 'close-create-hubspot-playlist-modal'
    });
    onClose();
  };
  const onSubmit = formInputs => {
    if (!playlist) return;
    const createVariables = {
      playlistId,
      active: false,
      name: formInputs.playlistName,
      description: formInputs.playlistDescription,
      internalName: formInputs.internalName,
      visibility: formInputs.visibility,
      difficulty: formInputs.difficulty,
      language: formInputs.primaryLanguage.toUpperCase()
    };
    const updateVariables = {
      playlistId,
      name: formInputs.playlistName,
      description: formInputs.playlistDescription,
      internalName: formInputs.internalName,
      visibility: formInputs.visibility,
      difficulty: formInputs.difficulty,
      language: formInputs.primaryLanguage.toUpperCase(),
      hiddenForOwner: playlist.hiddenForOwner,
      items: (playlist.items || []).map(({
        itemId,
        type,
        language
      }) => ({
        itemId,
        type,
        language: language.toString().toUpperCase()
      }))
    };
    if (action === 'create') {
      createHubspotPlaylistFromPlaylist({
        variables: createVariables
      }).catch(e => {
        Raven.captureException(e);
      });
    } else {
      updateHubspotPlaylist({
        variables: updateVariables
      }).catch(e => {
        Raven.captureException(e);
      });
    }
  };
  const isAnyLoading = playlistLoading || createHubspotPlaylistFromPlaylistLoading || updateHubspotPlaylistLoading;
  return /*#__PURE__*/_jsx(Modal, {
    width: 680,
    children: /*#__PURE__*/_jsx("div", {
      // Prevent any clicks from triggering the context menu to close, which in turn would de-render the modal
      onClick: e => {
        e.stopPropagation();
      },
      children: /*#__PURE__*/_jsx(FinalForm, {
        onSubmit: onSubmit,
        render: ({
          handleSubmit,
          invalid
        }) => /*#__PURE__*/_jsxs(Form, {
          onSubmit: e => {
            void handleSubmit(e);
          },
          children: [/*#__PURE__*/_jsxs(DialogHeader, {
            children: [/*#__PURE__*/_jsx(H2, {
              children: action === 'create' ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyCommon.playlists.hubspotPlaylists.createEditModal.createPlaylist"
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyCommon.playlists.hubspotPlaylists.createEditModal.editPlaylist"
              })
            }), /*#__PURE__*/_jsx(DialogCloseButton, {
              onClick: handleCloseButtonClick
            })]
          }), /*#__PURE__*/_jsxs(DialogBody, {
            children: [isAnyLoading && /*#__PURE__*/_jsx(View, {
              blockSize: "500",
              children: /*#__PURE__*/_jsx(LoadingSpinner, {
                grow: true,
                size: "medium"
              })
            }), playlistError && !playlistLoading && /*#__PURE__*/_jsx(ErrorMessage, {
              message: playlistError.errorMessage
            }), createHubspotPlaylistFromPlaylistError && /*#__PURE__*/_jsx(ErrorMessage, {
              message: createHubspotPlaylistFromPlaylistError.errorMessage
            }), updateHubspotPlaylistError && /*#__PURE__*/_jsx(ErrorMessage, {
              message: updateHubspotPlaylistError.errorMessage
            }), playlist && !isAnyLoading && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(FinalFormField, {
                fieldProps: {
                  name: 'playlistName',
                  initialValue: playlist.name
                },
                formControlProps: {
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.playlistName"
                  })
                },
                render: input => /*#__PURE__*/_jsx(TextInput, Object.assign({}, input, {
                  type: "text"
                })),
                validators: [required, notEmptyString]
              }), /*#__PURE__*/_jsx(FinalFormField, {
                fieldProps: {
                  name: 'playlistDescription',
                  initialValue: playlist.description
                },
                formControlProps: {
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.playlistDescription"
                  })
                },
                render: input => /*#__PURE__*/_jsx(TextArea, Object.assign({}, input)),
                validators: [required, notEmptyString]
              }), /*#__PURE__*/_jsx(FinalFormField, {
                fieldProps: {
                  name: 'primaryLanguage',
                  initialValue: action === 'create' ? 'en' : playlist.language
                },
                formControlProps: {
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.primaryLanguage.label"
                  }),
                  tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.primaryLanguage.tooltip"
                  }),
                  tooltipPlacement: 'right'
                },
                render: input => /*#__PURE__*/_jsx(Select, Object.assign({
                  options: supportedPublicLanguages.map(publicLang => ({
                    value: publicLang,
                    text: LanguageNames[publicLang]
                  }))
                }, input)),
                validators: [required, notEmptyString]
              }), /*#__PURE__*/_jsx(FinalFormField, {
                fieldProps: {
                  name: 'internalName',
                  initialValue: action === 'create' ? playlist.name : playlist.internalName
                },
                formControlProps: {
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.internalName.label"
                  }),
                  tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.internalName.tooltip"
                  }),
                  tooltipPlacement: 'right'
                },
                render: input => /*#__PURE__*/_jsx(TextInput, Object.assign({}, input, {
                  type: "text"
                })),
                validators: [required, notEmptyString]
              }), /*#__PURE__*/_jsx(FinalFormField, {
                fieldProps: {
                  name: 'visibility',
                  initialValue: playlist.visibility || 'PUBLIC'
                },
                formControlProps: {
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.visibility.label"
                  }),
                  tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.visibility.tooltip"
                  }),
                  tooltipPlacement: 'right'
                },
                render: input => /*#__PURE__*/_jsx(Select, Object.assign({
                  options: Visibilities.map(visibility => ({
                    value: visibility,
                    text: I18n.text(`academyCommon.playlists.hubspotPlaylists.createEditModal.visibility.options.${visibility}`)
                  }))
                }, input)),
                validators: [required, notEmptyString]
              }), /*#__PURE__*/_jsx(FinalFormField, {
                fieldProps: {
                  name: 'difficulty',
                  initialValue: action === 'create' ? Difficulties.BEGINNER : playlist.difficulty
                },
                formControlProps: {
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.difficulty.label"
                  }),
                  tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyCommon.playlists.hubspotPlaylists.createEditModal.difficulty.tooltip"
                  }),
                  tooltipPlacement: 'right'
                },
                render: input => /*#__PURE__*/_jsx(Select, Object.assign({
                  options: Object.values(Difficulties).map(value => ({
                    value,
                    text: I18n.text(`academyCommon.playlists.hubspotPlaylists.createEditModal.difficulty.options.${value}`)
                  }))
                }, input)),
                validators: [required, notEmptyString]
              }), /*#__PURE__*/_jsx(Alert, {
                marginBlockStart: "400",
                type: "warning",
                children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                  elements: {
                    Link
                  },
                  message: "academyCommon.playlists.acceptableUseDisclaimer_jsx",
                  options: {
                    href: 'https://legal.hubspot.com/acceptable-use',
                    external: true
                  }
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs(DialogFooter, {
            children: [/*#__PURE__*/_jsx(Button, {
              disabled: invalid || isAnyLoading || !playlist,
              type: "submit",
              use: "primary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyCommon.common.save"
              })
            }), /*#__PURE__*/_jsx(Button, {
              onClick: handleCloseButtonClick,
              use: "secondary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyCommon.common.cancel"
              })
            })]
          })]
        })
      })
    })
  });
};
export default CreateOrEditHubspotPlaylistModal;